// update Disclaimer visibility
export var PROFILE_UPDATE_DISCLAIMER_VISIBILITY = 'PROFILE_UPDATE_DISCLAIMER_VISIBILITY';

// profile load, update and save to backend.
export var PROFILE_LOAD_PROFILE = 'PROFILE_LOAD_PROFILE';
export var PROFILE_LOAD_META = 'PROFILE_LOAD_META';
export var PROFILE_LOAD_PROFILE_SECTION = 'PROFILE_LOAD_PROFILE_SECTION';
export var PROFILE_UPDATE_PROFILE = 'PROFILE_UPDATE_PROFILE';
export var PROFILE_SAVE_PROFILE = 'PROFILE_SAVE_PROFILE';
export var PROFILE_SAVE_EDUCATION_HISTORY = 'PROFILE_SAVE_EDUCATION_HISTORY';
export var PROFILE_SAVE_PROFILE_SECTION = 'PROFILE_SAVE_PROFILE_SECTION';
export var PROFILE_SAVE_PROFILE_SECTION_VALUE = 'PROFILE_SAVE_PROFILE_SECTION_VALUE';
export var PROFILE_SET_OPTIONS = 'PROFILE_SET_OPTIONS';
export var PROFILE_SET_ERRORS = 'PROFILE_SET_ERRORS';
export var PROFILE_SET_LOADING = 'PROFILE_SET_LOADING';
export var PROFILE_ADD_STUDENT_PROFILE_DOCUMENT_ACTION = 'PROFILE_ADD_STUDENT_PROFILE_DOCUMENT';
export var PROFILE_UPDATE_REQUIREMENT_ACTION = 'PROFILE_UPDATE_REQUIREMENT';
export var PROFILE_REMOVE_REQUIREMENT_FILE_ACTION = 'PROFILE_REMOVE_REQUIREMENT_FILE';
export var PROFILE_RETRIEVE_APPLICATIONS_ACTION = 'PROFILE_RETRIEVE_APPLICATIONS_ACTION';
export var PROFILE_SET_EDUCATION_HISTORY_ERRORS = 'PROFILE_SET_EDUCATION_HISTORY_ERRORS';

// SearchActions
export var PROFILE_CHANGED = 'PROFILE_CHANGED';
export var PROFILE_LOADED = 'PROFILE_LOADED';
export var PROFILE_OPTIONED = 'PROFILE_OPTIONED';
export var PROFILE_ERROR = 'PROFILE_ERROR';
export var PROFILE_CHANGE_PAGE = 'PROFILE_CHANGE_PAGE';
export var PROFILE_COMPLETED = 'PROFILE_COMPLETED';
export var PROFILE_STEP_ERROR = 'PROFILE_STEP_ERROR';
export var PROFILE_CHECKED = 'PROFILE_CHECKED';
export var PROFILE_RESET = 'PROFILE_RESET';
export var PROFILE_ELIGIBILITY_COMPLETED = 'PROFILE_ELIGIBILITY_COMPLETED';
export var VIEW_TOGGLE = 'VIEW_TOGGLE';

// card validation need access to pagestore;
// page is being updated passively and silently.
export var PROFILE_UPDATE_CARD_COMPLETED = 'PROFILE_UPDATE_CARD_COMPLETED';
export var PROFILE_UPDATE_PAGES_FROM_CARDS = 'PROFILE_UPDATE_PAGES_FROM_CARDS';
export var PROFILE_UPDATE_PAGE_FROM_CARDS = 'PROFILE_UPDATE_PAGE_FROM_CARDS';

// update page validity from cards/profile.
export var PROFILE_UPDATE_PAGE_COMPLETED_FROM_PROFILE = 'PROFILE_UPDATE_PAGE_COMPLETED_FROM_PROFILE';

// page navigation
export var PROFILE_INIT_PAGES = 'PROFILE_INIT_PAGES';
export var PROFILE_TOGGLE_SHOW_ALL_PAGE = 'PROFILE_TOGGLE_SHOW_ALL_PAGE';
export var PROFILE_UPDATE_PAGE = 'PROFILE_UPDATE_PAGE';
export var PROFILE_NEXT_PAGE = 'PROFILE_NEXT_PAGE';
export var PROFILE_LAST_PAGE = 'PROFILE_LAST_PAGE';
export var PROFILE_JUMP_TO_PAGE = 'PROFILE_JUMP_TO_PAGE';
export var SET_PROGRESS_BAR_ON_CLICK_ACTION = 'SET_PROGRESS_BAR_ON_CLICK_ACTION';
export var PROFILE_SET_PAGE_VISITED = 'PROFILE_SET_PAGE_VISITED';
export var PROFILE_EDUCATION_SET_EXPANDED_ID_ACTION = 'PROFILE_EDUCATION_SET_EXPANDED_ID';
export var SCROLL = 'SCROLL';
export var PROFILE_HIGHLIGHT_ADD = 'PROFILE_HIGHLIGHT_ADD';
export var PROFILE_HIGHLIGHT_REMOVE = 'PROFILE_HIGHLIGHT_REMOVE';
export var PERSONAL_INFO_OVERLAY_TOGGLE = 'PERSONAL_INFO_OVERLAY_TOGGLE';
export default {
  PROFILE_UPDATE_DISCLAIMER_VISIBILITY: PROFILE_UPDATE_DISCLAIMER_VISIBILITY,
  PROFILE_EDUCATION_SET_EXPANDED_ID_ACTION: PROFILE_EDUCATION_SET_EXPANDED_ID_ACTION,
  PROFILE_CHANGED: PROFILE_CHANGED,
  PROFILE_LOADED: PROFILE_LOADED,
  PROFILE_OPTIONED: PROFILE_OPTIONED,
  PROFILE_ERROR: PROFILE_ERROR,
  PROFILE_CHANGE_PAGE: PROFILE_CHANGE_PAGE,
  PROFILE_COMPLETED: PROFILE_COMPLETED,
  PROFILE_STEP_ERROR: PROFILE_STEP_ERROR,
  PROFILE_CHECKED: PROFILE_CHECKED,
  PROFILE_RESET: PROFILE_RESET,
  PROFILE_ELIGIBILITY_COMPLETED: PROFILE_ELIGIBILITY_COMPLETED,
  VIEW_TOGGLE: VIEW_TOGGLE,
  PROFILE_UPDATE_CARD_COMPLETED: PROFILE_UPDATE_CARD_COMPLETED,
  PROFILE_UPDATE_PAGES_FROM_CARDS: PROFILE_UPDATE_PAGES_FROM_CARDS,
  PROFILE_UPDATE_PAGE_FROM_CARDS: PROFILE_UPDATE_PAGE_FROM_CARDS,
  PROFILE_UPDATE_PAGE_COMPLETED_FROM_PROFILE: PROFILE_UPDATE_PAGE_COMPLETED_FROM_PROFILE,
  PROFILE_INIT_PAGES: PROFILE_INIT_PAGES,
  PROFILE_TOGGLE_SHOW_ALL_PAGE: PROFILE_TOGGLE_SHOW_ALL_PAGE,
  PROFILE_UPDATE_PAGE: PROFILE_UPDATE_PAGE,
  PROFILE_NEXT_PAGE: PROFILE_NEXT_PAGE,
  PROFILE_LAST_PAGE: PROFILE_LAST_PAGE,
  PROFILE_JUMP_TO_PAGE: PROFILE_JUMP_TO_PAGE,
  SET_PROGRESS_BAR_ON_CLICK_ACTION: SET_PROGRESS_BAR_ON_CLICK_ACTION,
  SCROLL: SCROLL,
  PROFILE_HIGHLIGHT_ADD: PROFILE_HIGHLIGHT_ADD,
  PROFILE_HIGHLIGHT_REMOVE: PROFILE_HIGHLIGHT_REMOVE,
  PERSONAL_INFO_OVERLAY_TOGGLE: PERSONAL_INFO_OVERLAY_TOGGLE
};